import { useCallback } from 'react';
import styled from '@emotion/styled';
import type { ActionMeta, GetOptionLabel, GetOptionValue, InputActionMeta, MultiValue } from 'react-select';
import Select from 'react-select';
import type { GroupTagOption } from '../../contexts/project-clips/interfaces';

type Props = {
  className?: string;
  inputValue: string;
  menuPortalTarget?: HTMLElement;
  noOptionsMessage: (obj: { inputValue: string }) => string | null;
  onChange: (value: MultiValue<GroupTagOption>, meta: ActionMeta<GroupTagOption>) => void;
  onInputChange: (newValue: string, actionMeta: InputActionMeta) => void;
  options: GroupTagOption[];
  selected: GroupTagOption[];
};

export const GroupTagsMultiSelect = ({
  className,
  inputValue,
  menuPortalTarget,
  noOptionsMessage,
  options,
  onChange,
  onInputChange,
  selected,
}: Props) => {
  const getOptionValue: GetOptionValue<GroupTagOption> = useCallback((o) => `${o.id}`, []);
  const getOptionLabel: GetOptionLabel<GroupTagOption> = useCallback((o) => o.name, []);

  return (
    <StyledSelect<GroupTagOption, true>
      className={className}
      components={{ DropdownIndicator: null }}
      styles={{ menu: (base: object) => ({ ...base, zIndex: 10 }) }}
      value={selected}
      inputValue={inputValue}
      isMulti
      options={options}
      placeholder="Search Global Tags..."
      noOptionsMessage={noOptionsMessage}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      onChange={onChange}
      onInputChange={onInputChange}
      menuPortalTarget={menuPortalTarget}
    />
  );
};

const StyledSelect = styled(Select)`
  font-size: 13px;
` as typeof Select;
